/** @jsxImportSource @emotion/react */
import DraggableModal from "components/DraggableModal/DraggableModal";
import React, {useContext, useEffect, useState} from 'react';
import {Button, Form, Space, Tabs, Typography} from 'antd';


;

//nowDate 参数数据
const Pane = ({
                  onRefresh,
                  visible,
                  setVisible,
                  submitCaseDoneSmSoDRs
              }) => {
    //主界面 Tab 控件对象，用于打开 Tab 页
    const {Text, Title} = Typography;
    // 加载显示
    // 组件初始化
    useEffect(() => {

    }, [visible]);

    return (
        <>
            <DraggableModal
                title='是否确认提交订单结案?'
                visible={visible}
                width={"20%"}
                onCancel={() => {
                    setVisible(false);
                }}
                destroyOnClose={true}
                maskClosable={false}
                closable={true}
                footer={
                    null
                }
            >

                <Form  layout="vertical" bordered={false} >

                    <Form.Item wrapperCol={{ offset: 14, span: 10 }}>
                        <Space>
                            <Button type={'primary'}  danger onClick={() => {
                                submitCaseDoneSmSoDRs(setVisible)
                            }}>否</Button>
                            <Button type={'primary'} onClick={() => {
                                submitCaseDoneSmSoDRs(setVisible)
                            }}>是</Button>
                        </Space>
                    </Form.Item>
                </Form>

            </DraggableModal>
        </>

    );
}

export default Pane;
